module.exports = __webpack_public_path__ + "static/media/guide.e58255fa.jpg";